<div class="report-info">{{ reportInfo }}</div>
<ng-container *ngIf="!restrictedData && data?.length>0">
    <app-reports-table *ngIf="dataLoaded && widgetType === 4" style="overflow: auto; max-height: 90%;"
        [notifier]="notifier" [data]="data" [columns]="columns" [groupByTime]="this.gridItem.setup.sysGroupByTime"
        [gridItem]="gridItem" [stepper]="stepper" [downloadDialogNotifier]="downloadDialogNotifier"
        [isInWizard]="isInWizard" [isStandAlone]="isStandAlone" [reportInfo]="reportInfo" [reportCode]="reportCode"
        [reportTitle]="reportTitle" [totals]="totals" [specialReportProperties]="specialReportProperties" [showTotal]="showTotal"></app-reports-table>
    <app-reports-barchart *ngIf="dataLoaded && widgetType !== 4" style="overflow: auto;max-height: 90%;"
        [notifier]="notifier" [data]="data" [columns]="columns" [groupByTime]="this.gridItem.setup.sysGroupByTime"
        [gridItem]="gridItem" [stepper]="stepper" [isInWizard]="isInWizard" [downloadDialogNotifier]="downloadDialogNotifier"
        [isStandAlone]="isStandAlone" [reportInfo]="reportInfo" [reportCode]="reportCode"></app-reports-barchart>
</ng-container>
<div *ngIf="restrictedData" class="restricted-data">
    <div class="restricted-icon"><i class="fal fa-eye-slash"></i></div>
    <span class="restricted-title">{{ 'Access not allowed' | i18next }}</span>
    <span class="restricted-description">{{ "You don't have a permission to see the data" | i18next }}</span>
</div>
<div *ngIf="!dataLoaded" class="data-loading">
    <i class="fal fa-sync fa-spin --fa-animation-duration:2s;"></i>
    <span>{{ 'dashboard:Loading' | i18next }}...</span>
</div>
<div *ngIf="data?.length == 0 && !restrictedData" class="restricted-data">
  <div class="no-data-icon"><i class="fal fa-database"></i></div>
  <ng-container *ngIf="!tooManyRecords">
    <span class="restricted-title">{{ 'dashboard:No data available' | i18next }}</span>
    <span class="restricted-description">{{ "dashboard:There is no data to show you right now." | i18next }}</span>
  </ng-container>
  <ng-container *ngIf="tooManyRecords">
    <span class="restricted-title">Sorry, too many records.</span>
    <span class="restricted-description">Please narrow the selected time period and try again.</span>
  </ng-container>
</div>
